import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from 'helper/className';
import { withTranslate } from '../../decorators/withTranslate';
import * as BaseRouteWrapper from '../../routes/baseRouteWrapper';
import { Link } from 'react-router';

const Logout = ({ className, t, headerData }) => (
  <Link to={BaseRouteWrapper.getLogout(headerData.module)}
        className={classNames(className, Logout.className)}
        title={t('Sign Out')}>
    <i className="fa fa-sign-out" />
  </Link>
);

Logout.className = 'logout';
Logout.getClassName = getClassNameGenerator(Logout.className);

Logout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  headerData: PropTypes.any,
  t: PropTypes.func
};

Logout.defaultProps = {

};

export default withTranslate()(Logout);
